const nb = (min, max) => new Intl.NumberFormat("nb-NO", { minimumFractionDigits: min, maximumFractionDigits: max });

export function fmtNumber(value, max = 2, min = 0) {
  if (value === null || value === undefined || value === "") return "–";
  const n = Number(value);
  if (Number.isNaN(n)) return "–";
  return nb(min, max).format(n);
}

export function fmtMoney(value) {
  if (value === null || value === undefined) return "–";
  const n = Number(value);
  if (Number.isNaN(n)) return "–";
  return `${nb(2, 2).format(n)} kr`;
}

export function fmtHours(hours) {
  if (hours === null || hours === undefined) return "–";
  return `${fmtNumber(hours, 2)} t`;
}

export function fmtMinutes(minutes) {
  if (minutes === null || minutes === undefined) return "–";
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (!h) return `${m} min`;
  return m ? `${h} t ${m} min` : `${h} t`;
}

/** Tolkar '1,5' / '1.5' -> 1.5. Returnerer null for tomt, NaN for ugyldig. */
export function parseDecimalInput(value) {
  if (value === null || value === undefined) return null;
  const text = String(value).trim().replace(/\s/g, "").replace(",", ".");
  if (!text) return null;
  if (!/^\d+(\.\d+)?$|^\.\d+$/.test(text)) return NaN;
  return Number(text);
}

/** Minutt-førehandsvising for timeinput (1,5 -> 90, 0,01 -> 1). */
export function previewMinutes(value) {
  const n = parseDecimalInput(value);
  if (n === null || Number.isNaN(n) || n <= 0) return null;
  return Math.max(1, Math.round(n * 60));
}

export function toInputDecimal(value) {
  if (value === null || value === undefined) return "";
  return String(value).replace(".", ",");
}

export function fmtDate(iso) {
  if (!iso) return "–";
  const d = iso.length === 10 ? new Date(`${iso}T00:00:00`) : new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("nb-NO", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function fmtDateTime(iso) {
  if (!iso) return "–";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("nb-NO", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function todayIso() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function fmtBytes(bytes) {
  if (bytes === null || bytes === undefined) return "–";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${fmtNumber(bytes / 1024, 0)} kB`;
  return `${fmtNumber(bytes / (1024 * 1024), 1)} MB`;
}
